import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const BulkEditHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  .header-right {
    text-align: end;
    margin-top: 16px;
  }

  ${responsive.MOBILE`
    .header-left > div {
      padding: 16px 0px;
    }
  `}
  
  .subtitle {
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin-left: 8px;
    margin-top: 8px;
  }
`;
